module.exports = __webpack_public_path__ + "static/media/dots-intro.089847a2.svg";